import { ChangeEvent, useMemo, useState, useCallback } from 'react';
import _ from 'lodash';
import { IEventAsset } from '@providers/EventProvider/interfaces';

export const useSearch = <T>(
  searchList: IEventAsset[],
  searchField: string | string[],
  tags: string[],
) => {
  const [inputValue, setInputValue] = useState('');
  const [debouncedInputValue, setDebouncedInputValue] = useState('');

  const filteredParticipants = useMemo(() => {
    if (!debouncedInputValue && !tags.length) {
      return searchList;
    }

    return searchList.filter((searchItem) => {
      let searchValue;

      if (Array.isArray(searchField)) {
        const field = searchField.find((field) => _.get(searchItem, field));
        if (field) {
          searchValue = _.get(searchItem, field);
        }
      } else {
        searchValue = _.get(searchItem, searchField);
      }

      const hasFilteredTags =
        tags.length === 0 ||
        (searchItem.tags &&
          searchItem.tags.some((tag: string) => tags.includes(tag)));

      const matchesSearch =
        !debouncedInputValue ||
        searchValue?.toLowerCase().includes(debouncedInputValue.toLowerCase());

      return hasFilteredTags && matchesSearch;

      return false;
    });
  }, [debouncedInputValue, searchField, searchList, tags]);

  const handleInputChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setInputValue(event.target.value);
      handleDebounceInputChange(event);
    },
    [],
  );

  const handleDebounceInputChange = useCallback(
    _.debounce((event: ChangeEvent<HTMLInputElement>) => {
      setDebouncedInputValue(event.target.value);
    }, 300),
    [],
  );

  const handleInputClear = useCallback(() => {
    setInputValue('');
    setDebouncedInputValue('');
  }, []);

  return {
    inputValue,
    filteredData: filteredParticipants,
    handleInputChange,
    handleInputClear,
  };
};
